import axios from "axios";

var Multiformularysearch = {
    initializeHeaders: function (headers) {
        axios.defaults.headers.common = headers;
    },
};

export default Multiformularysearch;




// WEBPACK FOOTER //
// ./src/models/Multiformularysearch.js